import {CalendarWorkdayInvitationListProps} from './types';

import {useAppSelector} from '@hooks';
import {getPendingWorkspaceReservationsByDate} from '@lib/store';
import {parseISO} from 'date-fns';
import {CalendarWorkdayInvitationCell} from '@organisms';

export const CalendarWorkdayInvitationList = ({
  date,
  color = 'energizingYellow',
}: CalendarWorkdayInvitationListProps) => {
  const pendingWorkspaceReservations = useAppSelector((state) =>
    getPendingWorkspaceReservationsByDate(state, parseISO(date)),
  );

  return (
    <>
      {!!pendingWorkspaceReservations?.length &&
        pendingWorkspaceReservations.map((workspace) => (
          <CalendarWorkdayInvitationCell
            {...{
              workspace,
              color,
              key: workspace.id,
              date,
            }}
          />
        ))}
    </>
  );
};
